const aerialPlotApi = process.env.aerialPlotConnections.aerialPlotApi.baseUrl;
const dataPlatformApi = process.env.aerialPlotConnections.aerialDataPlatformApi.baseUrl;

export function getUserLicenses(accessToken) {
	return fetch(`${aerialPlotApi}api/v1/UserLicenses`, {
		method: "GET",
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => {
			return res.json();
		})
		.then((data) => {
			return data;
		});
}

export function addUserLicense(accessToken, userLicense) {
	return fetch(`${aerialPlotApi}api/v1/UserLicenses`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Authorization: `Bearer ${accessToken}`,
		},
		body: JSON.stringify(userLicense),
	})
		.then((res) => {
			return res.json();
		})
		.then((data) => {
			return data;
		});
}

export function updateUserLicense(accessToken, userLicense) {
	return fetch(`${aerialPlotApi}api/v1/UserLicenses`, {
		method: "PUT",
		headers: {
			"Content-Type": "application/json",
			Authorization: `Bearer ${accessToken}`,
		},
		body: JSON.stringify(userLicense),
	})
		.then((res) => {
			return res.json();
		})
		.then((data) => {
			return data;
		});
}

export function removeUserLicense(accessToken, userLicenseId) {
	return fetch(`${aerialPlotApi}api/v1/UserLicenses?userLicenseId=${userLicenseId}`, {
		method: "DELETE",
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => {
			return res.json();
		})
		.then((data) => {
			return data;
		});
}

/**
 * Clear user and auth caches in python api- required after changing user licenses.
 */
export function clearAuthCachesInDataPlatform(accessToken, clientId) {
	return fetch(`${dataPlatformApi}Admin/ClearAuthCaches?clientId=${clientId}`, {
		method: "POST",
		headers: {
			Authorization: `Bearer ${accessToken}`,
		},
	})
		.then((res) => {
			return res.json();
		})
		.then((data) => {
			return data;
		});
}
